/**
 * @generated SignedSource<<d5b86cc1fd8e339c9f9f72c67897fd4b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useUserProfileAvailability_userProfile$data = {
  readonly hasCompletedIndyOnboarding: boolean;
  readonly visitorCanEdit: boolean;
  readonly workPreferences: {
    readonly availableUntil: ContraAPIScalars.Date | null;
    readonly isCurrentlyAvailable: boolean;
  };
  readonly " $fragmentType": "useUserProfileAvailability_userProfile";
};
export type useUserProfileAvailability_userProfile$key = {
  readonly " $data"?: useUserProfileAvailability_userProfile$data;
  readonly " $fragmentSpreads": FragmentRefs<"useUserProfileAvailability_userProfile">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useUserProfileAvailability_userProfile",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasCompletedIndyOnboarding",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "WorkPreferences",
      "kind": "LinkedField",
      "name": "workPreferences",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isCurrentlyAvailable",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "availableUntil",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "visitorCanEdit",
      "storageKey": null
    }
  ],
  "type": "UserProfile",
  "abstractKey": null
};

(node as any).hash = "ede6151279cf07037579cb2838b22eca";

export default node;
